<template>
  <div class="raw-image-map">
    <img  :src="raw_image.src" />
    <div class="description">
      <!-- <p
        class="name is-size-7"
      >{{raw_image.src.substring(raw_image.src.lastIndexOf('/') + 1).split("?")[0]}}</p> -->
      <p>
        <svg
          @click="forceDownload(raw_image.src)"
          viewBox="0 0 100 100"
          class="image is-32x32 mr-10"
        >
          <use xlink:href="@/assets/icons/helper_sprite.svg#download-fill" />
        </svg>
      </p>
    </div>
  </div>
</template>
<script>

export default {
  props: ["index", "raw_image"],
  data() {
    return {
      show_map: false,
      raw_images_map: null,
      map: null,
      marker: null,
      is_marker: false,
      marker_element: null
    };
  },
  mounted() {
  },
  methods: {
    // ...mapMutations(["SET_RAW_IMAGES_MAP"]),
    async loadMap() {
      this.raw_images_map = new mapboxgl.Map({
        container: "rawImageMap" + this.index,
        style: "mapbox://styles/mapbox/satellite-v8",
        center: [-75.789, 41.874],
        zoom: 5,
        maxZoom: 10,
        minZoom: 4,
        attributionControl: false
      });
      this.raw_images_map.on("load", () => {
        this.raw_images_map.removeLayer("satellite");
        this.raw_images_map.removeLayer("background");
        this.changeImage();
      });
    },
    changeImage() {
      // if (this.raw_images_map.getLayer("overlay"))
      //   this.raw_images_map.removeLayer("overlay");
      // if (this.raw_images_map.getSource("myImageSource"))
      //   this.raw_images_map.removeSource("myImageSource");

      const image = new Image();
      image.src = this.raw_image.src;
      image.setAttribute("crossorigin", "anonymous");
      image.onload = () => {
        const w = image.width;
        const h = image.height;
        let nw = this.raw_images_map.unproject([0, 0]);
        let ne = this.raw_images_map.unproject([w, 0]);
        let se = this.raw_images_map.unproject([w, h]);
        let sw = this.raw_images_map.unproject([0, h]);
        let bounds = new mapboxgl.LngLatBounds(
          new mapboxgl.LngLat(sw.lng, sw.lat),
          new mapboxgl.LngLat(ne.lng, ne.lat)
        );

        //   if (first_time)
        this.raw_images_map.setMaxBounds(bounds);

        this.raw_images_map.addSource("myImageSource", {
          type: "image",
          url: image.src,
          coordinates: [
            [nw.lng, nw.lat],
            [ne.lng, ne.lat],
            [se.lng, se.lat],
            [sw.lng, sw.lat]
          ]
        });
        this.raw_images_map.addLayer({
          id: "overlay",
          source: "myImageSource",
          type: "raster",
          paint: {
            "raster-opacity": 0.85
          }
        });

        let el = document.createElement("div");
        this.marker_element = el;
        el.className = "marker fa fa-map-marker fa-2x";
        //   if (!this.is_marker) this.marker_element.style.display = "none";
        //   el.addEventListener("click", () => (this.active_tab = 0));

        let location = this.raw_image.location;
        let center = this.raw_images_map.unproject([
          location[0],
          location[1] + 5
        ]);
        this.marker = new mapboxgl.Marker(el)
          .setLngLat(center)
          .addTo(this.raw_images_map);
        this.raw_images_map.resize();
        setTimeout(() => {
          this.raw_images_map.resize();
        }, 500);
      };
    },
    toggleMarker() {
      // if (!this.is_marker) this.marker_element.style.display = "block";
      // else this.marker_element.style.display = "none";
      this.is_marker = !this.is_marker;
      if (this.is_marker) this.loadMap();
    },
    forceDownload(url) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = "";
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      };
      xhr.send();
    }
  }
};
</script>

<style lang="scss">
.raw-image-map {
  padding: 0.5rem 1rem;
  .description {
    display: flex;
    justify-content: space-between;
    align-items: center;
    svg {
      cursor: pointer;
    }
  }
}
</style>